


















import Vue from 'vue';
import { mapGetters } from 'vuex';
import Component from 'vue-class-component';
import rootStore, { RootGetters, RootGetterTypes } from '@/rootStore';
import i18n from './i18n';
import store, {
  ActionTypes,
  Getters,
  GetterTypes,
  MutationTypes,
} from './store';
import Championship from './store/entity/Championship';

const RaceTrackView = () => import('./components/RaceTrackView.vue');
const SeasonBoxView = () => import('./components/SeasonBoxView.vue');
const CalendarView = () => import('./components/CalendarView.vue');
const RaceResultsView = () => import('./components/RaceResultsView.vue');
const AllRaceResultsView = () => import('./components/AllRaceResultsView.vue');
const StandingsView = () => import('./components/StandingsView.vue');

const F1SeasonProps = Vue.extend({
  props: {
    seasonYear: {
      type: Number,
      default: 2021,
    },
    viewMode: {
      type: String,
      default: 'view-track',
    },
    raceTrack: {
      type: String,
      default: '20',
    },
    raceTrackEventIndex: {
      type: Number,
      default: 0,
    },
  },
});

@Component({
  components: {
    RaceTrackView,
    SeasonBoxView,
    CalendarView,
    RaceResultsView,
    AllRaceResultsView,
    StandingsView,
  },
  computed: mapGetters({
    locale: RootGetterTypes.locale,
    championships: GetterTypes.championships,
  }),
  store: rootStore,
  i18n,
})
export default class F1Season extends F1SeasonProps {
  // Props have to be defined here as well to be type supported
  locale!: ReturnType<RootGetters[RootGetterTypes.locale]>
  championships!: ReturnType<Getters[GetterTypes.championships]>
  loading = true;

  // Computed properties
  get isRaceTrackView (): boolean {
    return this.viewMode === 'view-track';
  }

  get isSeasonBoxView (): boolean {
    return this.viewMode === 'view-next-race';
  }

  get isCalendarView (): boolean {
    return this.viewMode === 'view-season-calendar';
  }

  get isRaceResultsView (): boolean {
    return this.viewMode === 'view-track-results';
  }

  get isAllRaceResults (): boolean {
    return this.viewMode === 'view-season-results';
  }

  get isStandingsView (): boolean {
    return this.viewMode === 'view-season-standing';
  }

  get getCountryString (): string {
    const country = this.locale === 'de' ? 'DE' : 'US';
    return `${this.locale}-${country}`;
  }

  get loadingClass (): string {
    return this.loading
      ? 'is-loading'
      : '';
  }

  get championship (): Championship | undefined {
    if (this.championships.length > 0) {
      return this.championships.find((championship) => championship.getYear() === this.seasonYear);
    }
    return undefined;
  }

  created (): void {
    this.$store.registerModule('f1Season', store);

    this.$store.commit(MutationTypes.SET_SEASON_YEAR, this.seasonYear);

    if (this.isRaceTrackView) {
      this.$store.dispatch(ActionTypes.fetchTrack, { raceTrack: this.raceTrack, raceTrackEventIndex: this.raceTrackEventIndex })
        .then(() => {
          this.loading = false;
        });
    } else if (this.isSeasonBoxView || this.isRaceResultsView || this.isAllRaceResults || this.isStandingsView) {
      let loadedData = 0;
      this.$store.dispatch(ActionTypes.fetchEvents)
        .then(() => {
          loadedData += 1;
          if (loadedData === 2) {
            this.loading = false;
          }
        });
      this.$store.dispatch(ActionTypes.fetchChampionships)
        .then(() => {
          loadedData += 1;
          if (loadedData === 2) {
            this.loading = false;
          }
        });
    } else if (this.isCalendarView) {
      this.$store.dispatch(ActionTypes.fetchEvents)
        .then(() => {
          this.loading = false;
        });
    }
  }
}
